import { render } from "./QAQCOverviewShimmer.vue?vue&type=template&id=79ce42f2"
import script from "./QAQCOverviewShimmer.vue?vue&type=script&lang=js"
export * from "./QAQCOverviewShimmer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__